module.exports = __webpack_public_path__ + "static/smiling-woman-out-for-a-hike.3fd0202e.webp";